// @flow
import * as React from 'react';
import { Box, Button } from 'grommet';
import styled from 'styled-components';
import sidePanelMessages from 'esm-web-pro/messages/sidePanelMessages';
import { injectIntl, IntlShape } from 'react-intl';
import GreenButton from 'esm-web-pro/components/layout/GreenButton';


type Props = {
    handleClick: Function,
    intl: IntlShape,
}

const StyledBox = styled(Box)`
    position: absolute;
    bottom: 0;
    left: 0;
`;

const StyledGreenButton = styled(GreenButton)`
    width: 100%;
`;

const ButtonContainer = (props: Props) => {
    const { handleClick, intl: { formatMessage } } = props;
    return (
        <StyledBox
            direction="row"
            justify="around"
            alignSelf="center"
            width="100%"
            pad={{ horizontal: 'medium', vertical: 'small' }}
            gap="small"
        >
            <Box dirextion="row" height="32px" flex={{ grow: 1 }}>
                <StyledGreenButton
                    fill
                    alignSelf="end"
                    color="status-error"
                    style={{ padding: '0px 5px' }}
                    label={formatMessage(sidePanelMessages.closeButton)}
                    onClick={handleClick}
                />
            </Box>
        </StyledBox>
    );
};
export default injectIntl(ButtonContainer);
